const defaultTextValues = {
  subsectionOneTitle: {
    en: 'Useful links'
  },
  subsectionTwoTitle: {
    en: 'Useful links'
  },
  subsectionThreeTitle: {
    en: 'Useful links'
  },
  subsectionOneContent: {
    en: 'link'
  },
  subsectionTwoContent: {
    en: 'link'
  },
  subsectionThreeContent: {
    en: 'link'
  },
  socialIconsTitle: {
    en: 'Social media'
  }
};

export default defaultTextValues;
